export function push_ga_event(category, action, label) {
    window.ga("send", "event", category, action, label);
    window.ga("deprecated.send", "event", category, action, label);
}
